import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Image, Spinner } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

import { useDropzone } from "react-dropzone";
import config from "../../config";
import { toast } from "react-toastify";

const maxLength = 20;

function nameLengthValidator(file) {
  if (file.name.length > maxLength) {
    return {
      code: "name-too-large",
      message: `Name is larger than ${maxLength} characters`,
    };
  }
  return null;
}

const Instructor = () => {
  // Instructor form field
  const [full_name, setFull_name] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [file, setFile] = useState(null);
  const [agree, setAgree] = useState(false);
  const [errors, setErrors] = useState({});

  const [isSubmittingInstructor, setIsSubmittingInstructor] = useState(false);

  useEffect(() => {
    document.title = `Become an instructor | Agile Seekers`;
    document.getElementById("bodywrap").className = "baimain";
  }, []);

  // File type validation
  const validateFile = (file) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    return allowedTypes.includes(file.type);
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => {
      const file = files[0];
      if (file) {
        if (!validateFile(file)) {
          alert("Invalid file type! Please upload a PDF or DOC file.");
          return;
        }
        setFile(file); // Store the valid file
      }
    },
  });

  // Form validations
  const validate = () => {
    const newErrors = {};

    if (!full_name) {
      newErrors.full_name = "Full Name is required";
    } else if (full_name.trim().split(" ").length < 2) {
      newErrors.full_name = "Enter both first and last name";
    }

    if (!phone_number) {
      newErrors.phone_number = "Phone Number is required";
    }

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }

    if (!file) {
      newErrors.file = "Please upload a resume file before submitting.";
    }

    if (!agree) {
      newErrors.agree = "You must agree to the terms and conditions.";
    }

    return newErrors;
  };

  const instructor_submit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmittingInstructor(true);
      const formData = new FormData();
      formData.append("full_name", full_name);
      formData.append("email", email);
      formData.append("phone_number", phone_number);
      formData.append("resume", file); // Attach the file

      try {

        let response = await fetch(`${config.API_BASE_URL}/instructor`, {
          method: "POST",
          body: formData,
        });

        response = await response.json();

        if (response.status === 1) {

          // Split the name into an array
          const nameParts = full_name.split(" ");

          // Extract the first name and last name
          const zoho_firstname = nameParts[0];
          const zoho_lastname = nameParts[1];

          // Zoho Lead API Code Start
          const payload = {
            data: [
              {
                Company: "Agile",
                First_Name: zoho_firstname,
                Last_Name: zoho_lastname,
                Email: email,
                Phone: phone_number,
                Lead_Status: "New",
                Lead_Source: "Direct",
                Page_URL: window.location.href
              },
            ],
            trigger: ["approval", "workflow", "blueprint"],
          };

          try {
            const response = await fetch(`${config.API_BASE_URL}/zoho/instructor`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.status === 1) {
              setErrors({});

              // toast.success(result.message);
            } else {
              // toast.error(result.message);
              console.error("Zoho Error:", result);
            }
          } catch (error) {
            console.error("Fetch error:", error);
          }
          // Zoho Lead API Code End

          setErrors({});
          setFull_name("");
          setEmail("");
          setPhone_number("");
          setFile(null);
          setAgree(false);

          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An unexpected error occurred.");
      } finally {
        setIsSubmittingInstructor(false); // End the loading state
      }
    } else {
      setErrors(validationErrors);
    }
  };

  // Show file name
  const acceptedFileItems = acceptedFiles.map((file) => (
    <p key={file.path}>{file.name}</p>
  ));

  return (
    <>
      <Navbar />

      <section className="inst-wrap">
        <Container>
          <Row>
            <Col md={6} className="inst-left px-0">
              <div>
                <h3>Join Us as an Instructor</h3>
                <p className="mb-3">
                  Share your expertise and inspire learners around the world.
                </p>
                <Form>
                  <Form.Group className="mb-3" controlId="fname">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Full Name"
                      value={full_name}
                      onChange={(e) => setFull_name(e.target.value)}
                    />

                    {/* Full name validation */}
                    {errors.full_name && (
                      <div className="text-danger">{errors.full_name}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />

                    {/* email validation */}
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </Form.Group>



                  <Form.Group className="mb-3" controlId="contact">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Phone Number"
                      value={phone_number}
                      onChange={(e) => setPhone_number(e.target.value)}
                    />

                    {/* Phone number validation */}
                    {errors.phone_number && (
                      <div className="text-danger">{errors.phone_number}</div>
                    )}
                  </Form.Group>

                  <div {...getRootProps({ className: "dropzone mb-3" })}>
                    <input {...getInputProps()} />
                    <div>
                      <Image
                        src={`${config.BASE_URL}/assets/images/upload.png`}
                        className="img-fluid"
                        alt="upload"
                      />
                      <p>No file chosen</p>
                    </div>
                    <div>
                      <h5>Upload Resume (PDF, DOC)</h5>
                      <h6>Resume Upload</h6>
                    </div>
                  </div>

                  {/* file validation */}
                  {errors.file && (
                    <div className="text-danger">{errors.file}</div>
                  )}

                  {file ? <p className="mb-3">{acceptedFileItems}</p> : ""}

                  <Form.Group className="mb-3" id="agree">
                    <Form.Check
                      type="checkbox"
                      label="I agree to the terms and conditions."
                      checked={agree}
                      onChange={(e) => setAgree(e.target.checked)}
                    />

                    {/* I agree to the terms and conditions validation */}
                    {errors.agree && (
                      <div className="text-danger">{errors.agree}</div>
                    )}
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="button"
                    onClick={instructor_submit}
                    disabled={isSubmittingInstructor}
                  >
                    {isSubmittingInstructor ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="mx-2"
                        />
                        Loading...
                      </>
                    ) : (
                      "Apply Now"
                    )}
                  </Button>

                </Form>
              </div>
            </Col>
            <Col md={6} className="inst-right px-0">
              <Image
                src={`${config.BASE_URL}/assets/images/join.jpg`}
                className="img-fluid"
                alt="contact"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Instructor;
